// extracted by mini-css-extract-plugin
export default {"info":"TitleBar_info__H9x6u","container":"TitleBar_container__C2ESh"};